import { ofType } from 'redux-observable';
import { ajax } from 'rxjs/ajax';
import { of } from 'rxjs';
import { map, switchMap, catchError } from 'rxjs/operators';

import {
  CREATE_PARTNER_ACCOUNT,
  ASSIGN_REPORTS_TO_PARTNER_ACCOUNT,
  CREATE_PARTNER_ACCOUNT_FAILED,
} from '../../constants';

import { pushModal } from '../../actions/modal-actions';
import store from '../../store';

const createPartnerAccount = (action$, state$) =>
  action$.pipe(
    ofType(CREATE_PARTNER_ACCOUNT),
    switchMap(action =>
      ajax({
        url: `${state$.value.auth.server}/partners?v=${
          process.env.REACT_APP_VERSION
        }`,
        headers: {
          Authorization: state$.value.auth.token,
        },
        responseType: 'json',
        crossDomain: true,
        body: JSON.stringify(action.payload),
        method: 'POST',
      }).pipe(
        map(response => {

          return {
            type: ASSIGN_REPORTS_TO_PARTNER_ACCOUNT,
            clientId: response.response.client.id,
            payload: action.reports,
          };
        }),
        catchError(error => {
          if (error.response.status === 'EMAIL_IN_USE') {
            store.dispatch(
              pushModal({
                title: 'Email Address In Use',
                message:
                  'An account with that email address already exists.',
              })
            );
          }
          return of({
            type: CREATE_PARTNER_ACCOUNT_FAILED,
            error,
          })}
        )
      )
    )
  );

export default createPartnerAccount;
